import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { DOCGEN_MONTHLY_STATEMENT_TASK_BASE_PATH } from '../../../../../../../../../../features/generate/monthly-statement/task/docgen-monthly-statement-task-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task')(
  {
    loader: () =>
      ({
        breadcrumb: buildBreadcrumb({
          id: `monthly-statement-task-list`,
          label: 'Monthly Statements',
          to: DOCGEN_MONTHLY_STATEMENT_TASK_BASE_PATH,
        }),
      }) satisfies AggregateBreadcrumb,
  },
);
